import { useQuery } from "@tanstack/react-query";

import type { ICountryObject } from "app/services/CountryService";
import { DefaultFetchService } from "app/services/fetchService";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

import type { Keyword } from "./types";

const KEYWORDS_VOLUMES_ENDPOINT = "api/MarketResearch/DemandSearchTrends/KeywordsVolumes";

export interface KeywordsVolumesResponse {
    Data: Record<string, { Keyword: string; AverageVolume: number }>;
}

interface UseKeywordsVolumesProps<TData = KeywordsVolumesResponse> {
    keywords: Keyword[];
    country: ICountryObject;
    enabled?: boolean;
    select?: (data: KeywordsVolumesResponse) => TData;
}

export const useKeywordsVolumes = <TData>({
    keywords,
    country,
    enabled = false,
    select,
}: UseKeywordsVolumesProps<TData>) => {
    const terms = keywords.map((keyword) => keyword.term);

    return useQuery({
        queryKey: [KEYWORDS_VOLUMES_ENDPOINT, country.id, ...terms],
        queryFn: async ({ signal }) => {
            const fetchService = DefaultFetchService.getInstance();
            const params = {
                websource: devicesTypes.TOTAL,
                keywords: terms.join(","),
                country: country.id,
            };
            return fetchService.get<KeywordsVolumesResponse>(KEYWORDS_VOLUMES_ENDPOINT, params, {
                cancellation: signal,
            });
        },
        enabled,
        select,
    });
};
